import { createRootRoute, Outlet } from '@tanstack/react-router';
import { AuthGuard } from '@/components/guards/AuthGuard';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="min-h-screen bg-background">
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    </div>
  );
}
